export default __webpack_public_path__ + "static/media/cytocaare-banner-12.885ce996.jpg";